"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

const cache_1 = require("./cache");

function initializeDataReader(apiFn) {
  const apiFnCache = cache_1.resourceCache(apiFn);

  for (var _len = arguments.length, parameters = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    parameters[_key - 1] = arguments[_key];
  }

  const cachedResource = apiFnCache.get(...parameters);

  if (cachedResource) {
    return cachedResource;
  }

  let data;
  let status = 'init';
  let error;
  const fetchingPromise = apiFn(...parameters).then(result => {
    data = result;
    status = 'done';
  }).catch(err => {
    error = err;
    status = 'error';
  });

  function dataReaderFn(modifier) {
    if (status === 'init') {
      throw fetchingPromise;
    } else if (status === 'error') {
      throw error;
    }

    return typeof modifier === 'function' ? modifier(data) : data;
  }

  apiFnCache.set(dataReaderFn, ...parameters);
  return dataReaderFn;
}

exports.initializeDataReader = initializeDataReader;